// src/pages/TestLinks.js
import React from 'react';
import { Link } from 'react-router-dom';

export default function TestLinks() {
  return (
    <div className="p-6 text-white bg-black min-h-screen">
      <h1 className="text-2xl font-bold mb-4">Testzugänge zum Feedback-Formular</h1>

      <div className="space-y-4">
        <Link
          to="/feedback?uid=123&milestone=kennenlerntermin&role=mentor&mentee_id=456"
          className="block bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 rounded w-fit"
        >
          Feedback als Mentor (uid=123, mentee_id=456)
        </Link>

        <Link
          to="/feedback?uid=456&milestone=kennenlerntermin&role=mentee"
          className="block bg-green-500 hover:bg-green-400 text-white font-bold py-2 px-4 rounded w-fit"
        >
          Feedback als Mentee (uid=456)
        </Link>
      </div>
    </div>
  );
}
